export const SUMMARY_ATTRIBUTION_1_7 = '1d_view_7d_click'
export const getAttributions = parsedResults => [
  {
    id: '1d_view',
    title: '1d view',
    value: Number(parsedResults?.['1d_view'] ?? 0)
  },
  {
    id: '7d_view',
    title: '7d view',
    value: Number(parsedResults?.['7d_view'] ?? 0)
  },
  {
    id: '1d_click',
    title: '1d click',
    value: Number(parsedResults?.['1d_click'] ?? 0)
  },
  {
    id: '7d_click',
    title: '7d click',
    value: Number(parsedResults?.['7d_click'] ?? 0)
  },
  {
    id: '28d_click',
    title: '28d click',
    value: Number(parsedResults?.['28d_click'] ?? 0)
  },
  {
    id: SUMMARY_ATTRIBUTION_1_7,
    title: '1d view + 7d click',
    value: Number(parsedResults?.['1d_view'] ?? 0) + Number(parsedResults?.['7d_click'] ?? 0)
  }
]
